import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  ConstuntivoChargesStorargeModel, ConsuntivoChargesByRefMonthModel,
  ConsuntivoChargesModel,
  ConsuntivoChargesReportModel
} from '../../../../models/ConsuntivoChargesModel';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {ReferenceMonthFilterComponent} from '../../../general-components/filter/reference-month-filter/reference-month-filter.component';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {ResourceUnitFilterComponent} from '../../../general-components/filter/resource-unit-filter/resource-unit-filter.component';
import {ContractTypeFilterComponent} from '../../../general-components/filter/contract-type-filter/contract-type-filter.component';
import {ActualQuantityFilterComponent} from '../../../general-components/filter/actual-quantity-filter/actual-quantity-filter.component';
import {WorkflowStatusFilterComponent} from '../../../archive/workflow-status-filter/workflow-status-filter.component';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../../models/OffsetModel';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {ConsuntivoChargesService} from '../../consuntivo-charges/service-consuntivo-charges/consuntivo-charges.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {ResourceUnitService} from '../../../general-services/service-resources-units-anagraf/resource-unit.service';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';
import { MatDialog } from '@angular/material/dialog';
import {DialogSendEmailComponent} from '../../../general-components/dialog-send-email/dialog-send-email.component';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';


@Component({
  selector: 'app-charges-by-reference-month-filter',
  templateUrl: './charges-by-reference-month-filter.component.html',
  styleUrls: ['./charges-by-reference-month-filter.component.scss']
})
export class ChargesByReferenceMonthFilterComponent extends BaseGeneralComponent implements OnInit {
  @Input() numAnnoMeseData?: any;
  @Input() filter?: ConsuntivoChargesModel;
  @Input() isRecovery?: boolean;
  @Input() reportSection?: boolean;
  @Input() isArchive?: boolean;

  contractTypeData?: any;
  regionData: any;
  localCustomerData: any;
  resourceUnitData: any;

  @Output() dataFiltered = new EventEmitter<any>();

  // @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;
  @ViewChild(ReferenceMonthFilterComponent, { static: true }) referenceMonthFilterComponent;
  @ViewChild(RegionFilterComponent, { static: true }) regionFilterComponent;
  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(ResourceUnitFilterComponent, { static: true }) resourceUnitFilterComponent;
  @ViewChild(ContractTypeFilterComponent, { static: true }) contractTypeFilterComponent;
  @ViewChild(ActualQuantityFilterComponent, { static: true }) actualQuantityFilterComponent;
  @ViewChild(WorkflowStatusFilterComponent) workFlowStatusFilterComponent;

  filterSingle: AllSettingsFilterModel;
  listShareNameFilter: any[];
  listApplicationCodFilter: any[];
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  recovery: any;
  labelAnnoMeseRif: string;
  intermittentBool: boolean;

  @Input() isComparing?: boolean;

  actualQuantityFilter: number;

  constructor(private loaderService: LoaderService,
              private consuntivoChargersService: ConsuntivoChargesService,
              private numAnnoMeseService: NumAnnoMeseService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private resourceUnitService: ResourceUnitService,
              private contractTypeService: ContractTypeService,
              private dialog: MatDialog
  ) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new ConsuntivoChargesModel();
    }
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.isRecovery = this.isRecovery;
    this.filterSingle = AllSettingsFilterModel.getFromConsuntivoChargesModel(this.filter);
    this.labelAnnoMeseRif = 'Reference Month';
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CONSUMPTIVE_CHARGES_FILTER))) {
      const filterStorage: ConstuntivoChargesStorargeModel = JSON.parse(
        sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CONSUMPTIVE_CHARGES_FILTER)
      );
      this.filter = filterStorage;
      this.actualQuantityFilter = filterStorage.actualQuantityFilter;
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CONSUMPTIVE_CHARGES_FILTER));
    } else {
      this.actualQuantityFilter = 1;
      this.filter.actualQuantityFilter = 1;
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      allSettingsFilterModel);
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      allSettingsFilterModel).pipe();

    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable,
      getAllResourceUnitObservable, getAllContractTypeObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.contractTypeData = resultFork[3];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit({filter: this.getFilterItem(), actualQuantityFilter: this.actualQuantityFilter});
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }
  interceptRegionChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.resourceUnitData = resultFork[1];
          this.contractTypeData = resultFork[2];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.resourceUnitData = resultFork[1];
          this.contractTypeData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptResourceUnitChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.resourceUnit = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    /** const getAllNumAnnoMeseFilteredObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
     this.filterSingle.contractType).pipe(); **/
    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          // this.numAnnoMeseData = resultFork[0];
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.resourceUnitData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          /** if (!BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
            const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
            this.filter.numAnnoMese = numAnnoMese;
          } **/

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptNumAnnoMeseChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptNumAnnoMeseFromChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptActualQuantityFilterChange($event) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      const filterStorage: ConstuntivoChargesStorargeModel = this.filter as ConstuntivoChargesStorargeModel;
      filterStorage.actualQuantityFilter = this.actualQuantityFilter;
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.CONSUMPTIVE_CHARGES_FILTER, JSON.stringify(filterStorage));
    }
    this.dataFiltered.emit({filter: this.getFilterItem(), actualQuantityFilter: this.actualQuantityFilter});
  }

  private getFilterItem() {
    const filterItem = this.filter;
    if (!this.isArchive) {
      filterItem.workflowStatus = undefined;
    }
    return filterItem;
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new ConsuntivoChargesModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.isRecovery = this.isRecovery;
    this.filterSingle = AllSettingsFilterModel.getFromConsuntivoChargesModel(this.filter);

    // this.filter.numAnnoMeseRif = null;
    this.filter.contractType = null;
    this.filter.region = null;
    this.filter.resourceUnit = null;
    this.filter.workflowStatus = null;

    this.referenceMonthFilterComponent.reset();
    this.contractTypeFilterComponent.reset();
    this.regionFilterComponent.reset();
    this.resourceUnitFilterComponent.reset();
    if (this.workFlowStatusFilterComponent) {
      this.workFlowStatusFilterComponent.reset();
    }

    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        const providerDefault = this.filter.provider;
        this.numAnnoMeseData =  this.filterFromDxc(providerDefault, resultYearMonth);

        // const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
        // this.filter.numAnnoMese = numAnnoMese;

        this.actualQuantityFilter = null;

        const filterStorage: ConstuntivoChargesStorargeModel = this.filter as ConstuntivoChargesStorargeModel;
        filterStorage.actualQuantityFilter = this.actualQuantityFilter;

        sessionStorage.setItem(this.SESSION_STORAGE_LABELS.CONSUMPTIVE_CHARGES_FILTER, JSON.stringify(this.filter));
        this.filterSingle = AllSettingsFilterModel.getFromConsuntivoChargesModel(this.filter);

        this.initFilter(this.filterSingle, isReset);

        this.loaderService.display(false);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
      });
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.consuntivoChargersService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.consuntivoChargersService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as ConsuntivoChargesByRefMonthModel;
    reportFilter.numAnnoMeseRif = this.filter.numAnnoMeseRif;
    if (this.reportSection) {
      reportFilter.numAnnoMeseRifTo = this.referenceMonthFilterComponent.optionSelected;
      reportFilter.numAnnoMeseRifFrom = this.referenceMonthFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseRifTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseRifFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseRifFrom && reportFilter.numAnnoMeseRifTo) {
      reportFilter.numAnnoMeseRifFrom = reportFilter.numAnnoMeseRifTo;
    } else if (reportFilter.numAnnoMeseRifFrom && !reportFilter.numAnnoMeseRifTo) {
      reportFilter.numAnnoMeseRifTo = reportFilter.numAnnoMeseRifFrom;
    }
/*    else {
      console.error('year month filter is missing');
      toastr.error('year month filter is missing');
      return;
    }*/
    this.offset.actualQuantityFilter = this.actualQuantityFilter;
    reportFilter.actualQuantityFilter = this.actualQuantityFilter;
    this.loaderService.display(true);
    this.generateConsuntivoChargesXlsx(reportFilter);
  }

  shareXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as ConsuntivoChargesByRefMonthModel;
    reportFilter.numAnnoMeseRif = this.filter.numAnnoMeseRif;
    if (this.reportSection) {
      reportFilter.numAnnoMeseRifTo = this.referenceMonthFilterComponent.optionSelected;
      reportFilter.numAnnoMeseRifFrom = this.referenceMonthFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseRifTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseRifFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseRifFrom && reportFilter.numAnnoMeseRifTo) {
      reportFilter.numAnnoMeseRifFrom = reportFilter.numAnnoMeseRifTo;
    } else if (reportFilter.numAnnoMeseRifFrom && !reportFilter.numAnnoMeseRifTo) {
      reportFilter.numAnnoMeseRifTo = reportFilter.numAnnoMeseRifFrom;
    }
    /*    else {
          console.error('year month filter is missing');
          toastr.error('year month filter is missing');
          return;
        }*/
    this.offset.actualQuantityFilter = this.actualQuantityFilter;

    const dialogRef = this.dialog.open(DialogSendEmailComponent, {
      data: {
        currentBaseUrl: this.consuntivoChargersService.baseUrl,
        offset: this.offset,
        isComparing: this.isComparing,
        filter: reportFilter
      }
    });
  }

  generateConsuntivoChargesXlsx(reportFilter) {
    const fileName = 'Charges by reference month';
    // let fileName = 'Monthly Charges';
    // if (this.filter.isRecovery) {
    //   fileName = 'Charges Balance';
    // }
    this.getNameSubscribe = this.consuntivoChargersService.getNameGenerateXlsx(this.offset, reportFilter, this.isComparing)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              fileName + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),
              // fileName + ' - ' + currentDate + '.xlsx');
              fileName + ' - ' + currentDate + ' From ' + reportFilter.numAnnoMeseRifFrom + ' To ' + reportFilter.numAnnoMeseRifTo + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  getDate() {
    const date = new Date();
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    this.offset.actualQuantityFilter = this.actualQuantityFilter;

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.CONSUMPTIVE_CHARGES}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMeseRif = this.referenceMonthFilterComponent.optionSelected;
    }
    this.filter.numAnnoMeseRif = this.referenceMonthFilterComponent.optionSelected;
    this.filter.region = this.regionFilterComponent.getSelectedObject();
    this.filter.localCustomer = this.localCustomerFilterComponent ? this.localCustomerFilterComponent.getSelectedObject() : null;
    this.filter.resourceUnit = this.resourceUnitFilterComponent.getSelectedObject();
    this.filter.contractType = this.contractTypeFilterComponent.getSelectedObject();
    this.filter.isRecovery = this.isRecovery;
    this.actualQuantityFilter = this.actualQuantityFilterComponent.optionSelected;
    if (this.isArchive) {
      this.filter.workflowStatus = this.workFlowStatusFilterComponent.optionSelected;
    }
    this.loaderService.display(false);
  }

  isLocalCustomerFilterActive(): boolean {
    if (this.filter && this.filter.provider && this.filter.provider.cod) {
      if (this.filter.provider.cod === 'DXC') { return false; } else { return true; }
    }
    console.error('no provider found');
    return false;
  }
}
